/* ChinaTourly prototype interactions
   Restrained: scroll reveal + anchor active state + date selector + pay button intent.
   Respects prefers-reduced-motion. */
(function(){
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Scroll reveal via IntersectionObserver
  if (!REDUCED && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function(el){ el.classList.add('is-in'); });
  }

  // Anchor nav active state on scroll
  var nav = document.querySelector('.anchor-nav');
  if (nav) {
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var sections = links.map(function(a){ return document.querySelector(a.getAttribute('href')); }).filter(Boolean);
    function updateActive() {
      var y = window.scrollY + 200;
      var idx = 0;
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].offsetTop <= y) idx = i;
      }
      links.forEach(function(a, i){ a.classList.toggle('is-active', i === idx); });
    }
    window.addEventListener('scroll', updateActive, { passive: true });
    updateActive();
  }

  // Date selector + holiday surcharge
  var dateInput = document.querySelector('[data-ct-date]');
  if (dateInput) {
    var base = parseFloat(dateInput.getAttribute('data-base') || '0');
    var priceEl = document.querySelector('[data-ct-price]');
    function isSpringFestival(d){ var m=d.getMonth()+1, day=d.getDate(); if(m===1&&day>=20)return true; if(m===2&&day<=18)return true; return false; }
    function isNationalDay(d){ return d.getMonth()+1===10 && d.getDate()>=1 && d.getDate()<=7; }
    function isOtherHoliday(d){ var m=d.getMonth()+1,day=d.getDate();
      if(m===4&&day>=3&&day<=7)return true; if(m===5&&day>=1&&day<=5)return true;
      if(m===6&&day>=7&&day<=12)return true; if(m===9&&day>=14&&day<=22)return true; return false; }
    function fmt(n){ return '$' + Math.round(n).toLocaleString(); }
    dateInput.addEventListener('change', function(){
      var v = dateInput.value;
      if (!v || !priceEl) return;
      var d = new Date(v + 'T12:00:00');
      var supp = 0, label = 'Standard date - no seasonal supplement';
      if (isSpringFestival(d)) { supp = 50; label = 'Spring Festival window: +50%'; }
      else if (isNationalDay(d)) { supp = 50; label = 'National Day Golden Week: +50%'; }
      else if (isOtherHoliday(d)) { supp = 20; label = 'Chinese national holiday: +20%'; }
      var total = base * (1 + supp/100);
      priceEl.innerHTML = '<strong>' + fmt(total) + '</strong><small>' + label + ' &nbsp;|&nbsp; 20% deposit option: ' + fmt(total * 0.2) + '</small>';
    });
  }

  // Themed departure-window cards for route products.
  var dateOptions = document.querySelector('[data-ct-date-options]');
  if (dateOptions) {
    var optionBase = parseFloat(dateOptions.getAttribute('data-base') || '0');
    var optionPrice = document.querySelector('[data-ct-price]');
    var optionDetail = document.querySelector('[data-ct-date-detail]');
    function detailSlots(raw){
      return String(raw || '').split('|').filter(Boolean).map(function(item, idx){
        return '<span' + (idx === 0 ? ' class="is-hot"' : '') + '>' + item + '</span>';
      }).join('');
    }
    function updateDetail(card, total){
      if (!optionDetail) return;
      var label = card.getAttribute('data-label') || card.querySelector('strong').textContent;
      var seats = card.getAttribute('data-seats') || '6';
      var booked = card.getAttribute('data-booked') || '2';
      var guide = card.getAttribute('data-guide') || '2';
      var note = card.getAttribute('data-note') || 'Balanced window with private guide and hotel checks before payment.';
      var slots = card.getAttribute('data-slots') || 'Tue 4 open|Thu 3 open|Sun 2 open';
      optionDetail.innerHTML =
        '<span class="date-detail__eyebrow">Selected window</span>' +
        '<h4>' + label + '</h4>' +
        '<p>' + note + '</p>' +
        '<div class="date-detail__grid">' +
          '<div class="date-detail__metric"><strong>' + seats + '</strong><span>Seats held</span></div>' +
          '<div class="date-detail__metric"><strong>' + booked + '</strong><span>Recent holds</span></div>' +
          '<div class="date-detail__metric"><strong>' + guide + '</strong><span>Guide teams</span></div>' +
        '</div>' +
        '<div class="date-detail__slots">' + detailSlots(slots) + '</div>';
    }
    function money(n){ return '$' + Math.round(n).toLocaleString(); }
    dateOptions.querySelectorAll('[data-ct-choice]').forEach(function(card){
      card.addEventListener('click', function(){
        if (card.classList.contains('is-locked')) return;
        dateOptions.querySelectorAll('[data-ct-choice]').forEach(function(c){ c.classList.remove('is-active'); });
        card.classList.add('is-active');
        var supp = parseFloat(card.getAttribute('data-supp') || '0');
        var label = card.getAttribute('data-label') || card.querySelector('strong').textContent;
        var total = optionBase * (1 + supp / 100);
        if (optionPrice) {
          optionPrice.innerHTML = '<strong>' + money(total) + '</strong><small>' + label + ': ' + supp + '% supplement. 20% deposit option: ' + money(total * 0.2) + '.</small>';
        }
        updateDetail(card, total);
      });
    });
    var firstActive = dateOptions.querySelector('[data-ct-choice].is-active');
    if (firstActive) {
      updateDetail(firstActive, optionBase * (1 + parseFloat(firstActive.getAttribute('data-supp') || '0') / 100));
    }
  }

  // Pay buttons: Shopify pages submit the route form; static prototypes show a note.
  document.querySelectorAll('[data-pay-intent]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var intent = btn.getAttribute('data-pay-intent');
      var form = document.querySelector('[data-ct-route-form]');
      if (form) {
        e.preventDefault();
        var existing = form.querySelector('input[name="properties[Payment intent]"]');
        if (!existing) {
          existing = document.createElement('input');
          existing.type = 'hidden';
          existing.name = 'properties[Payment intent]';
          form.appendChild(existing);
        }
        existing.value = intent === 'deposit' ? '20% deposit' : 'pay full';
        form.submit();
        return;
      }
      e.preventDefault();
      window.alert('[Prototype] Pay intent: ' + intent + '\nIn Shopify, this submits the route product form.');
    });
  });
})();
